<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.999023 15V12.5821L9.71569 3.86544L12.1336 6.28333L3.41692 15H0.999023ZM12.9538 1.09522L14.9038 3.04522C15.0335 3.17496 15.0335 3.38338 14.9038 3.51311L13.7324 4.68456L11.3145 2.26667L12.4859 1.09522C12.5489 1.03226 12.6293 1 12.7157 1C12.8114 1 12.8888 1.03022 12.9538 1.09522Z"
      stroke="#2F7F91"
      stroke-linejoin="round"
    />
  </svg>
</template>
